import React, { useState, useEffect } from 'react';
import festivalsData from './ukfestivals.json';
import './Festivals.css';

function UKFestivalApp() {
  const [selectedFestivalId, setSelectedFestivalId] = useState('');
  const [festival, setFestival] = useState(null);

  useEffect(() => {
    const loadVoices = () => {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length === 0) {
        setTimeout(loadVoices, 100);
      }
    };
    loadVoices();
  }, []);

  const speak = (text, langCode) => {
    const synth = window.speechSynthesis;
    const voices = synth.getVoices();
    const voice = voices.find(v => v.lang === langCode);
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = langCode;
    if (voice) utterance.voice = voice;
    synth.speak(utterance);
  };

  const allFestivals = Array.isArray(festivalsData)
    ? festivalsData
    : festivalsData.flatMap(group => group.festivals || []);

  useEffect(() => {
    const selected = allFestivals.find(f => f.id === selectedFestivalId);
    setFestival(selected || null);
  }, [selectedFestivalId, allFestivals]);

  return (
    <div className="app">
      <h1>🎉 Festivals in U.K</h1>

      <select value={selectedFestivalId} onChange={e => setSelectedFestivalId(e.target.value)}>
        <option value="">Select Festival</option>
        {allFestivals.map(f => (
          <option key={f.id} value={f.id}>{f.name}</option>
        ))}
      </select>

      {festival && (
        <div className="festival-details">
          <h2>{festival.name}</h2>

          {/* English */}
          <div className="language-block">
            <h3>📘 In English</h3>
            {festival.details.english.lines.map((line, i) => <p key={i}>{line}</p>)}
            <button onClick={() => speak(festival.details.english.lines.join(' '), 'en-US')}>🔊 Read Aloud (English)</button>
          </div>

          {/* Polish */}
          <div className="language-block">
            <h3>🇵🇱 In Polish</h3>
            {festival.details.polish.lines.map((line, i) => <p key={i}>{line}</p>)}
            <button onClick={() => speak(festival.details.polish.lines.join(' '), 'pl-PL')}>🔊 Read Aloud (Polish)</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default UKFestivalApp;
